import React, { useRef, useEffect } from 'react';

import { useDispatch } from 'react-redux';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import './AnalyticsRealTimeColumns.scss';

import Icon from '../../atoms/Icon/Icon';
import Tooltip from '../../atoms/Tooltip/Tooltip';
import AnalyticsRealTimeMedia from '../AnalyticsRealTimeMedia/AnalyticsRealTimeMedia';
import {
  analyticsDashboard,
  fetchMoreAnalyticsDashboardContent // need to un comment
  // callNewsrromRequestUpdate
} from '../../../Apis/actions/analytics-dashboard-actions';

const AnalyticsRealTimeColumns = ({
  accessUser,
  analyticsDashboardCard,
  cardType,
  collectionType,
  collection,
  data,
  hideTooltip,
  iconName,
  iconSize,
  liveProfile,
  loading,
  loadingMore,
  requestReplies,
  setSection,
  title,
  toolTipContent,
  redact,
  isMobile,
  currentCollection,
  setCurrentCollection,
  hideHover,
  setHideHover,
  showDropDown,
  setShowDropDown,
  setDropDownValue,
  dropDownRef,
  dropDownOptions
}) => {
  const stableDispatch = useDispatch();
  const collectionBottomRef = useRef(null);
  const scrollAreaRef = useRef(null);

  const emptyMedia = new Array(20).fill({});

  const parsedMedia = loading || loadingMore ? [...data.results, ...emptyMedia] : data.results; // need to un comment
  // const parsedMedia = [...emptyMedia];

  // const { customAssociatedConversationRequestId } = useSelector(
  //   (state) => state.analyticsDashboardReducer
  // );

  const isEmailPresent = JSON.parse(localStorage.getItem('userData'))?.email;
  const isTokenPresent = JSON.parse(localStorage.getItem('userData'))?.token;

  useEffect(() => {
    const options = {
      root: scrollAreaRef.current,
      rootMargin: '0px',
      threshold: 0.25
    };

    const handleMediaObserver = (entities) => {
      const target = entities[0];
      // fetch more content when user gets to the buttom of a dashboard content collection
      if (target.isIntersecting) {
        stableDispatch(
          // need to un comment
          fetchMoreAnalyticsDashboardContent({
            type: 'SCROLL_DOWN',
            category: collectionType.toUpperCase()
          })
        ); // need to un comment
      }
    };

    const observer = new IntersectionObserver(handleMediaObserver, options);
    if (collectionBottomRef.current) {
      observer.observe(collectionBottomRef.current);
    }
  }, [stableDispatch, collectionType, collection]);

  const callCustomCollectionManually = (requestId) => {
    stableDispatch(
      analyticsDashboard(
        {
          type: 'INITIAL',
          category: 'LIVE_REPLIES',
          user_email: requestId,
          email: isEmailPresent,
          token: isTokenPresent
        },
        false,
        requestId
      )
    );
  };

  return (
    <>
      <section
        className={classNames('tmx-analyticsRealTimeColumns__list', {
          'tmx-analyticsRealTimeColumns__list--active':
            currentCollection === collectionType && isMobile
        })}>
        <div className="tmx-analyticsRealTimeColumns__searchWrapper">
          <div className="tmx-analyticsRealTimeColumns__dashBoardColHeading">
            <div
              ref={currentCollection === collectionType && isMobile ? dropDownRef : null}
              className={classNames('tmx-analyticsRealTimeColumns__dashBoardContainer', {
                'tmx-analyticsRealTimeColumns__dashBoardContainer--noHover': hideHover || !isMobile
              })}>
              <Tooltip content={toolTipContent} hideTooltip={hideTooltip}>
                <Link
                  to={'#'}
                  className={classNames('tmx-analyticsRealTimeColumns__link')}
                  onClick={() => {
                    if (isMobile) {
                      setShowDropDown(!showDropDown);
                      if (showDropDown) {
                        setHideHover(true);
                      } else {
                        setHideHover(false);
                      }
                    }
                  }}>
                  <Icon
                    name={iconName}
                    size={iconSize}
                    className="tmx-analyticsRealTimeColumns__clearedIconLeft"
                  />
                  <h3 className="tmx-analyticsRealTimeColumns__listTitle--stacked">{title}</h3>
                </Link>
              </Tooltip>
              <Icon
                name="chevron"
                size="medium"
                className="tmx-analyticsRealTimeColumns__dropDownIcon"
                onClick={() => {
                  if (isMobile) {
                    setShowDropDown(!showDropDown);
                    if (showDropDown) {
                      setHideHover(true);
                    } else {
                      setHideHover(false);
                    }
                  }
                }}
              />
              <div
                className={classNames('tmx-analyticsRealTimeColumns__dropDownOptions', {
                  hide: !showDropDown
                })}>
                {dropDownOptions.map((ele, ind) => (
                  <div
                    key={ind}
                    className="tmx-analyticsRealTimeColumns__dropDownContainer"
                    onClick={(event) => {
                      setCurrentCollection(ele.collectionType);
                      setDropDownValue(event, ele.collectionType);
                    }}
                    onKeyDown={(event) => {
                      setCurrentCollection(ele.collectionType);
                      setDropDownValue(event, ele.collectionType);
                    }}
                    tabIndex={0}
                    role="button">
                    <Icon
                      name={ele.icon}
                      size={ele.icon === 'messages-2' ? 'ginormous' : 'huge'}
                      className="tmx-analyticsRealTimeColumns__clearedIconLeft"
                    />
                    <p key={ind}>{ele.name}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="tmx-analyticsRealTimeColumns__iconMainContainer">
              <div className={classNames('tmx-analyticsRealTimeColumns__IconSubContainer')}>
                <Icon
                  name={'search'}
                  size="small"
                  className={classNames('tmx-analyticsRealTimeColumns__clearedIconRight')}
                  onClick={() => {}}
                />
              </div>
            </div>
          </div>
        </div>

        <section
          className="tmx-analyticsRealTimeColumns__collectionContainer"
          id={collectionType}
          ref={scrollAreaRef}
          onScroll={() => {
            setShowDropDown(false);
            if (isMobile) {
              setHideHover(true);
            }
          }}>
          <div className={classNames('tmx-analyticsRealTimeColumns__mediaContainer')}>
            {parsedMedia?.map((media, ind) => (
              <AnalyticsRealTimeMedia
                accessUser={accessUser}
                requestReplies={requestReplies}
                analyticsDashboardCard={analyticsDashboardCard}
                liveProfile={liveProfile}
                setSection={setSection}
                cardType={cardType}
                media={media}
                loaded={data.loaded}
                // loaded={false}
                key={ind}
                collectionType={collectionType}
                loading={loading || !media.id}
                redact={redact}
                hideSubMediaData={collectionType === 'messenger_queue' ? false : true}
                callCustomCollectionManually={
                  callCustomCollectionManually
                }></AnalyticsRealTimeMedia>
            ))}
            <div ref={collectionBottomRef}></div>
          </div>
        </section>
      </section>
    </>
  );
};

AnalyticsRealTimeColumns.propTypes = {
  accessUser: PropTypes.bool,
  analyticsDashboardCard: PropTypes.bool,
  cardType: PropTypes.number,
  collectionType: PropTypes.string,
  collection: PropTypes.string,
  data: PropTypes.shape({
    contactDetail: PropTypes.string,
    contactType: PropTypes.string,
    contactTitle: PropTypes.string,
    uploadTime: PropTypes.string,
    uploaderName: PropTypes.string,
    uploaderCompanyName: PropTypes.string,
    action: PropTypes.string,
    companyName: PropTypes.string,
    contactName: PropTypes.string,
    profilePic: PropTypes.string,
    email: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    isLoggedIn: PropTypes.bool,
    lastLogin: PropTypes.string,
    loaded: PropTypes.bool,
    mediaId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    orgPic: PropTypes.string,
    results: PropTypes.array,
    state: PropTypes.string,
    thumbnail: PropTypes.string,
    time: PropTypes.string,
    timestamp: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    title: PropTypes.string,
    type: PropTypes.string,
    userId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    searchTerm: PropTypes.string,
    description: PropTypes.string,
    invitedEmails: PropTypes.array,
    uploader: PropTypes.string,
    verified: PropTypes.bool,
    occupation: PropTypes.string,
    location: PropTypes.string,
    searchedFields: PropTypes.shape({
      AKAS: PropTypes.string,
      'Address line 1': PropTypes.string,
      'Address line 2': PropTypes.string,
      'Age range': PropTypes.string,
      'Date of birth': PropTypes.string,
      'First name': PropTypes.string,
      'Last name': PropTypes.string,
      'Middle name': PropTypes.string,
      Phone: PropTypes.string
    }),
    requestExpert: PropTypes.shape({
      Purpose: PropTypes.string,
      'Show Name': PropTypes.string,
      'Shooting Preference': PropTypes.string,
      'Type of expert': PropTypes.string,
      'Topics that will be discussed': PropTypes.string,
      'Additional info (optional)': PropTypes.string
    }),
    replyMessage: PropTypes.string,
    replyContactName: PropTypes.string,
    replyOrg: PropTypes.string,
    replyLocation: PropTypes.string,
    replyOccupation: PropTypes.string,
    replyOrgPic: PropTypes.string,
    uploaderLocation: PropTypes.string
  }),
  hideTooltip: PropTypes.bool,
  iconName: PropTypes.string,
  iconSize: PropTypes.string,
  liveProfile: PropTypes.bool,
  loading: PropTypes.bool,
  loadingMore: PropTypes.bool,
  requestReplies: PropTypes.bool,
  setSection: PropTypes.func,
  title: PropTypes.string,
  toolTipContent: PropTypes.string,
  redact: PropTypes.bool,
  isMobile: PropTypes.bool,
  currentCollection: PropTypes.string,
  setCurrentCollection: PropTypes.func,
  hideHover: PropTypes.bool,
  setHideHover: PropTypes.func,
  showDropDown: PropTypes.bool,
  setShowDropDown: PropTypes.func,
  setDropDownValue: PropTypes.func,
  dropDownRef: PropTypes.any,
  dropDownOptions: PropTypes.any
};

AnalyticsRealTimeColumns.defaultProps = {
  redact: false
};

export default AnalyticsRealTimeColumns;
